export default __webpack_public_path__ + "static/media/1.3cc9af9f.png";